import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { Tooltip } from 'primeng/tooltip';

@Component({
  selector: 'sh-form-label',
  templateUrl: './form-label.component.html',
  styleUrls: ['./form-label.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [Tooltip],
})
export class FormLabelComponent {
  @Input() for: string;
  @Input() required: boolean;
  @Input() tooltip: string;
}
